module.exports = __webpack_public_path__ + "img/service-traffic.8dd35040.jpg";